import React, {useCallback, useEffect, useMemo, useState} from "react";
import { Button, Badge, Col, Form, Modal, Row } from "react-bootstrap";
import {DateTime} from "luxon";

function MarkNoShowModal(props) {
    const [messageText, setMessageText] = useState("");

    const handleClearAndClose = () => {
        setMessageText("");
        props.onHide();
    };

    const handleSubmitData = () => {
        props.submit(messageText);
        handleClearAndClose();
    };

    const appntStartLocal = useCallback((bookingDetails) => {
        let dt = bookingDetails?.appntStartEpochSec && bookingDetails?.appntStartEpochSec?.length > 0
            ? DateTime.fromMillis(bookingDetails.appntStartEpochSec * 1000)
            : DateTime.fromISO(bookingDetails?.appntStart);

        if(!bookingDetails?.eventTimeZone){
            return `${dt.toFormat("LLL dd, yyyy hh:mm a")} - ${bookingDetails?.eventTimeZone}`;
        }

        const dateTimeInZone = dt.setZone(bookingDetails.eventTimeZone);
        return `${dateTimeInZone.toFormat("LLL dd, yyyy hh:mm a")} - ${bookingDetails?.eventTimeZone}`;
    }, []);

    return (
        <Modal {...props} size="xl" aria-labelledby="contained-modal-title-vcenter" centered>
            <Form id={"sendMessageForm"}>
                <Modal.Header id="modalHeader">
                    <Modal.Title>{props.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body id="modalBody">
                    <div style={{ fontSize: '20px', textAlign: "left", color: "green" }}>
                        <p>{props.subTitle}</p>
                    </div>
                    <Form.Group controlId="formLink">
                        <Row>
                            <Col style={{ flex: 1.6 }}>
                                <Form.Label>Note</Form.Label>
                                <Form.Control
                                    style={{ border: "1px solid lightgray", background: "rgba(0,0,0,0.05)" }}
                                    as="textarea"
                                    rows={10}
                                    value={messageText}
                                    onChange={e => setMessageText(e.target.value)}
                                />
                            </Col>
                            <Col style={{ flex: 0.4 }}>
                                <b>Booking Demographic Details</b>
                                <br/>
                                <div style={{ textAlign: "left" }}>
                                    Name : &nbsp; {props.details?.firstName} {props.details?.lastName}
                                </div>
                                <div style={{ textAlign: "left" }}>Id : &nbsp; {props.details?.id}</div>
                                <br/>
                                <div style={{ textAlign: "left" }}>Location : &nbsp; {props.details?.careLocation?.address}</div>
                                <br/>
                                <div style={{ textAlign: "left" }}>Date-time : &nbsp; {appntStartLocal(props.details)}</div>
                                <br/>
                                <div style={{ textAlign: "left" }}>Email : &nbsp; {props.details?.email}</div>
                                <div style={{ textAlign: "left" }}>Phone : &nbsp; {props.details?.phone}</div>
                            </Col>
                        </Row>
                        <hr></hr>
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="light" type="button" onClick={handleClearAndClose}>
                        Cancel
                    </Button>
                    {/* <Button id="msg_reply" class="replyButton sendButton text-right" onClick={() => submitSaveDraft()}>
                Save Draft
              </Button> */}
                    <Button id="msg_reply" class="" onClick={handleSubmitData}>
                        Submit
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default MarkNoShowModal;
